









import { Component, Prop, Vue } from 'vue-property-decorator';
import { TEntity } from '@/plugins/podolib/services/entities/Entity';
import { TAcquisition, TPatient } from '@/plugins/podolib/services/entities/EntityPatients';

import ChartRunningPhaseAdvancedStrikePattern from '@/components/charts/running/ChartRunningPhaseAdvancedStrikePattern.vue';

@Component({
  components: { ChartRunningPhaseAdvancedStrikePattern },
})
export default class PatientAcquisitionExportationFrameRunningContainerChartStrikePattern extends Vue {
  @Prop({ required: true }) private patient!: TEntity<TPatient>;
  @Prop({ required: true }) private acquisition!: TEntity<TAcquisition>;
}
